import { SVGProps } from 'react';

const UnableToLoadGraphic = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="360"
      height="240"
      viewBox="0 0 360 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0007 167.687C12.2039 108.817 266.579 -32.8588 321.302 16.9863C376.026 66.8313 338.859 175.709 238.197 213.579C137.534 251.45 13.7983 226.557 13.0007 167.687Z"
        fill="#F2F2F2"
      />
      <rect
        x="71.2889"
        y="46.4695"
        width="217.203"
        height="146.356"
        rx="9.78814"
        fill="white"
        stroke="#DDE3E9"
        strokeWidth="2.79661"
      />
      <path
        d="M69.8906 56.2577C69.8906 50.0796 74.899 45.0712 81.0771 45.0712H278.704C284.882 45.0712 289.891 50.0796 289.891 56.2577V71.1729H69.8906V56.2577Z"
        fill="#DDE3E9"
      />
      <circle cx="86.6692" cy="58.1217" r="3.72881" fill="#C5CFD6" />
      <circle cx="99.721" cy="58.1217" r="3.72881" fill="#C5CFD6" />
      <circle cx="112.771" cy="58.1217" r="3.72881" fill="#C5CFD6" />
      <circle
        cx="179.891"
        cy="128.169"
        r="32.4939"
        fill="#102F56"
        stroke="white"
        strokeWidth="5.32688"
      />
      <rect
        x="176.162"
        y="111.124"
        width="7.45763"
        height="21.3075"
        rx="3.72881"
        fill="white"
      />
      <circle cx="179.89" cy="141.486" r="3.72881" fill="white" />
    </svg>
  );
};

export default UnableToLoadGraphic;
